import React, { FC, useState, useEffect } from 'react';
import { extractQueryStringFromParams } from 'utils';
import { useQuery } from '@apollo/client';
import * as AuthQuery from 'graphql/auth.graphql';
import Email from './Email';
import EmailConfirmation from './EmailConfirmation';
import Organization from './Organization';
import Password from './Password';
import PageWithLogoLine from 'components/PageWithLogoLine';
import { ValidateEmailConfirmationToken } from 'api/data/user/types';

const Signup: FC = () => {
  const [email, setEmail] = useState(extractQueryStringFromParams('email'));
  const [invalidTokenMessage, setInvalidTokenMessage] = useState<undefined | string>(undefined);
  const [step, setStep] = useState('EMAIL');
  const token = extractQueryStringFromParams('token');
  const { data, loading: loadingValidateEmail } = useQuery<ValidateEmailConfirmationToken>(
    AuthQuery.ValidateEmailConfirmationToken,
    {
      variables: { token },
      skip: !token,
    },
  );

  useEffect(() => {
    if (loadingValidateEmail) {
      return;
    }

    if (data?.validateEmailConfirmationToken) {
      setStep('PASSWORD');
    } else if (token) {
      setInvalidTokenMessage('Invalid or expired token. Please try again.');
    }
  }, [data, loadingValidateEmail, token]);

  const stepComponent: {
    [key: string]: JSX.Element;
  } = {
    EMAIL: <Email setStep={setStep} email={email} setEmail={setEmail} invalidTokenMessage={invalidTokenMessage} />,
    EMAIL_CONFIRMATION: <EmailConfirmation email={email} />,
    PASSWORD: <Password setStep={setStep} userEmail={email} />,
    ORGANIZATION: <Organization />,
  };

  return <PageWithLogoLine>{loadingValidateEmail ? 'Loading...' : stepComponent[step]}</PageWithLogoLine>;
};

export default Signup;
